import {getService} from "~/lib/services/services-manager";
import {Client} from "~/lib/models/client";
import {User} from "~/lib/models/user";

export const getClientDetails = async (clientUUID) => {
  const service = getService("server-app");
  const result = await service.get(`/admin-client/client/${clientUUID}/details`);
  return new Client(result.data.client);
};

export const getClientSubscriptionDate = async uuid => {
  const service = getService("server-app");
  const result = await service.get(`/admin-client/client/${uuid}/subscription`);
  return result.data;
};

export const getClientRolesConfig = async userUUID => {
  const service = getService("server-app");
  const result = await service.get(`/admin-client/client/${userUUID}/roles-config`);
  return result.data.rolesConfig;
}
